module.exports = __webpack_public_path__ + "static/media/fedex.e35ff0ad.png";